import PropTypes from 'prop-types';
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  PERIOD_SCALE_ENUM,
  DISPLAY_UNIT_ENUM
} from '~/modules/resourcing/common/enums';
import { ResourceMatchItem } from '~/modules/resourcing/common/components';
import { RESOURCE_MATCH_ITEM_BUTTONS } from '~/modules/resourcing/common/components/ResourceMatchItem/enums';
import {
  ResourceRequestMatchItemInfo,
  ResourceRequestMatchItemNoMatches,
  ResourceRequestMatchItemLoading,
  ResourceRequestMatchItemMatch
} from './components';

const useStyles = makeStyles(theme => ({
  root: {
    margin: theme.spacing(0.5, 1)
  }
}));

export const ResourceRequestMatchItem = ({
  classes: classesOverride,
  resourceRequest,
  scale,
  displayUnit,
  maxSkillLevel,
  setAnchorEl,
  setPopoverResourceRequest,
  project,
  isPsaPraaResourceMatchingEnabled = false
}) => {
  const classes = useStyles();
  const resourceMatchesLength = resourceRequest.resourceMatches?.length;

  return (
    <div className={classes.root}>
      <ResourceRequestMatchItemInfo
        resourceRequest={resourceRequest}
        maxSkillLevel={maxSkillLevel}
      />
      {isPsaPraaResourceMatchingEnabled ? (
        <ResourceMatchItem
          classes={classesOverride}
          dataQeId="ResourceRequestMatchItem"
          resourceRequest={resourceRequest}
          buttonType={RESOURCE_MATCH_ITEM_BUTTONS.ACCEPT}
          setAnchorEl={setAnchorEl}
          setPopoverResourceRequest={setPopoverResourceRequest}
          project={project}
          narrow
        />
      ) : resourceMatchesLength > 0 ? (
        <ResourceRequestMatchItemMatch
          resourceRequest={resourceRequest}
          setAnchorEl={setAnchorEl}
          setPopoverResourceRequest={setPopoverResourceRequest}
          project={project}
        />
      ) : resourceMatchesLength === 0 ? (
        <ResourceRequestMatchItemNoMatches
          resourceRequest={resourceRequest}
          scale={scale}
          displayUnit={displayUnit}
        />
      ) : (
        <ResourceRequestMatchItemLoading dataQeId={resourceRequest.id} />
      )}
    </div>
  );
};

ResourceRequestMatchItem.propTypes = {
  classes: PropTypes.object,
  resourceRequest: PropTypes.object.isRequired,
  scale: PropTypes.oneOf(Object.values(PERIOD_SCALE_ENUM)),
  displayUnit: PropTypes.oneOf(Object.values(DISPLAY_UNIT_ENUM)),
  maxSkillLevel: PropTypes.number,
  setAnchorEl: PropTypes.func.isRequired,
  setPopoverResourceRequest: PropTypes.func.isRequired,
  project: PropTypes.object.isRequired,
  isPsaPraaResourceMatchingEnabled: PropTypes.bool
};

export default ResourceRequestMatchItem;
